import { ELms, ELtiVersion, LMS_LABELS, LMS_SETUP_GUIDE_URLS } from 'pages/integrations/components/lti/constants';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';

type SetupStepsLinksProps = {
    lmsList: ELms[];
    ltiVersion: ELtiVersion;
};

/**
 * The "Setup Steps:" row of per-LMS links shown at the bottom of each registration section.
 * Each link opens the GMetrix Knowledge Base article for connecting that LMS at the section's
 * own LTI version (see LMS_SETUP_GUIDE_URLS) in a new tab.
 */
export const SetupStepsLinks = (props: SetupStepsLinksProps) => {

    const { lmsList, ltiVersion } = props;

    return (
        <div className="d-flex flex-wrap align-items-center gap-3 setup-steps-links">
            <span className="fw-bold small mb-0">
                <FormattedMessage defaultMessage="Setup Steps:" id="setup_steps.d1af7689" />
            </span>
            {lmsList.map(lms => (
                <Button
                    className="p-0 align-baseline text-decoration-none"
                    href={LMS_SETUP_GUIDE_URLS[ltiVersion][lms]}
                    key={lms}
                    rel="noopener noreferrer"
                    target="_blank"
                    variant="link"
                >
                    {LMS_LABELS[lms]}
                    <i className="fa-solid fa-arrow-up-right-from-square ms-1 small" />
                </Button>
            ))}
        </div>
    );

};
